import { DocumentReference, getDoc, getDocs, Query } from 'firebase/firestore';

export class NavigatorNetworkError extends Error {
  constructor(message = 'You are offline!') {
    super(message);
  }
}

export const fetchDocs = async <T>(reference: Query<T>) => {
  const snapshot = await getDocs(reference);

  if (snapshot.empty && snapshot.metadata.fromCache && !navigator.onLine) {
    throw new NavigatorNetworkError();
  }

  return snapshot;
};

export const fetchDoc = async <T>(reference: DocumentReference<T>) => {
  const snapshot = await getDoc(reference);

  // if (!snapshot.exists && snapshot.metadata.fromCache && !navigator.onLine) {
  //   throw new NavigatorNetworkError();
  // }

  return snapshot;
};
